import { FirmaApi } from '@/shared/formalizacion-client';

export default class FirmaService extends FirmaApi {}
